export default __webpack_public_path__ + "static/media/Wine-Bar-Vibe.d6319667.jpg";